import { useCallback, useEffect, useState } from 'react';
import { Menu } from '../../../../components/common/menu/DropdownMenu';
import { FlightContextMenuContent } from '../../../../components/map-interaction/context-menu/FlightContextMenuContent';
import { MapContextMenu } from '../../../../components/map-interaction/context-menu/MapContextMenu';
import { useEvent } from '../../../contexts/event-bus';
import { useAppSelector } from '../../../hooks/store-hooks';

export function TutorialComponents() {
    const tutorialActive = !!useAppSelector((x) => x.global.tutorial);
    const [flightContextMenu, setFlightContextMenu] = useState<false | { x: number; y: number }>(false);

    useEffect(() => {
        if (!tutorialActive) {
            setFlightContextMenu(false);
        }
    }, [tutorialActive]);

    useEvent(
        'tutorial-component',
        useCallback((args) => {
            if (args === null) {
                setFlightContextMenu(false);
            } else if (args.type === 'flight-context-menu') {
                const element = document.querySelector(args.elementId);
                if (element) {
                    const rect = element.getBoundingClientRect();

                    setFlightContextMenu({
                        x: rect.left + rect.width / 2 - 100,
                        y: rect.top + rect.height / 2 - 200
                    });
                }
            }
        }, [])
    );

    return (
        <>
            {flightContextMenu && (
                <MapContextMenu
                    open={true}
                    position={{
                        x: flightContextMenu.x,
                        y: flightContextMenu.y
                    }}>
                    <Menu>
                        <FlightContextMenuContent id={-1} />
                    </Menu>
                </MapContextMenu>
            )}
        </>
    );
}
